import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Returns a click handler that returns to the previous in-app location.
// Falls back to `fallback` (a path string or a getter returning one) when
// there is no in-app history to pop, e.g. a deep link, refresh or new tab.
export const useGoBack = (fallback) => {
    const navigate = useNavigate();
    const location = useLocation();

    return useCallback(
        (event) => {
            // Let the browser handle new-tab/new-window intents on real links.
            if (
                event &&
                (event.defaultPrevented ||
                    event.button === 1 ||
                    event.metaKey ||
                    event.altKey ||
                    event.ctrlKey ||
                    event.shiftKey)
            ) {
                return;
            }
            event?.preventDefault();
            if (location.key === 'default') {
                const path =
                    typeof fallback === 'function' ? fallback() : fallback;
                navigate(path);
            } else {
                navigate(-1);
            }
        },
        [navigate, location.key, fallback]
    );
};
